module.exports = __webpack_public_path__ + "img/icon_search-b.6cf6f1f8.svg";